import { OnboardingImageContainer, OnboardingImageContent } from './styles';

interface OnboardingImageProps {
  src: string;
  alt: string;
}

const OnboardingImage: React.FC<OnboardingImageProps> = ({ src, alt }) => {
  return (
    <OnboardingImageContainer>
      <OnboardingImageContent>
        <img src={src} alt={alt} />
      </OnboardingImageContent>
    </OnboardingImageContainer>
  );
};

export default OnboardingImage;
